export const emptyFct = () => {};
